import React, { useState } from 'react';

import Button from 'common/components/core/Button/Button';
import type { DialogProps } from 'common/components/core/Dialog/Dialog';
import Dialog, { DialogSize } from 'common/components/core/Dialog/Dialog';
import { useEvent } from 'common/components/hooks/useEvent/useEvent';

type NewVersionDialogProps = DialogProps & {
  onReload: () => void;
};

export function NewVersionDialog(props: NewVersionDialogProps) {
  const [loading, setLoading] = useState(false);

  const handleReload = useEvent(() => {
    setLoading(true);
    props.onReload();
  });

  return (
    <Dialog
      title="New version of NC2 is available"
      actions={
        <Button onClick={handleReload} loading={loading} data-test="new-version-dialog-reload-button">
          Reload to update
        </Button>
      }
      hideClose={true}
      size={DialogSize.SMALL}
      isOpen={true}
      {...props}
      onClose={handleReload}
      className="backdrop-blur"
    >
      <p>We have just deployed the latest version of NC2.</p>
    </Dialog>
  );
}
